import { ApiUser, getUser } from '@/api/user';
import * as Sentry from '@sentry/browser';
import smartlookClient from 'smartlook-client';
import Vuex from 'vuex';

export const buildStore = async () => {
    let user: ApiUser | null = null;
    let shop = '';

    try {
        user = await getUser();
    } catch (error) {
        if (error.request.status !== 401) {
            window.captureException(error);
        } else {
            shop = error.request?.response?.shop;
        }
    }

    // Set user for Sentry logging
    if (user) {
        smartlookClient.identify(user.customilyUser.Id, {
            name: user.customilyUser.Name,
            username: user.customilyUser.Username
        });

        Sentry.setUser({
            username: user.customilyUser.Username,
            id: user.customilyUser.Id.toString()
        });

        Sentry.setContext('store', {
            store: user.client_actual_domain
        });

        // Start session recording only for genuine logins
        if (!user.customilyUser.UserImpersonatedFromId) {
            window.rumStartRecording();
        } else {
            // Stop recording just in case
            window.rumStopRecording();
        }
    }

    const store = new Vuex.Store({
        state: {
            user: user,
            store: user?.client_actual_domain || shop || ''
        },
        mutations: {
            setStore(state, store: string) {
                state.store = store;

                Sentry.setContext('store', {
                    store: store
                });
            }
        }
    });

    return store;
};
